import { render } from "./InstallmentApprovalsPage.vue?vue&type=template&id=546a1b9b&scoped=true"
import script from "./InstallmentApprovalsPage.vue?vue&type=script&lang=js"
export * from "./InstallmentApprovalsPage.vue?vue&type=script&lang=js"

import "./InstallmentApprovalsPage.vue?vue&type=style&index=0&id=546a1b9b&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/ibsreg-test.theismailiusa.org/github-httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546a1b9b"]])

export default __exports__